import { render, staticRenderFns } from "./TextareaBlock.vue?vue&type=template&id=22a8c755&scoped=true"
import script from "./TextareaBlock.vue?vue&type=script&lang=js"
export * from "./TextareaBlock.vue?vue&type=script&lang=js"
import style0 from "./TextareaBlock.vue?vue&type=style&index=0&id=22a8c755&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8c755",
  null
  
)

export default component.exports